var render = function () {
  var _vm$identityCard;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12 pt-0"
    }
  }, [_c('Title', {
    attrs: {
      "text-start": "",
      "font-weight": 600,
      "font-size": 14,
      "title": "Документ удостоверяющий личность",
      "append-icon": "mdi-trash-can-outline"
    },
    on: {
      "click:append-outer": _vm.removeIdentityCard
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.country,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setIdentityCard
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Гражданство")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.identityCard.citizenship,
      callback: function callback($$v) {
        _vm.$set(_vm.identityCard, "citizenship", $$v);
      },
      expression: "identityCard.citizenship"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showIdentityCardDocTypeName,
      expression: "!showIdentityCardDocTypeName"
    }],
    attrs: {
      "items": _vm.dictionaries.identityCardDocType,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "persistent-hint": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "hint": "Если вы не нашли тип документа в выпадающем списке, введите название вручную, нажав на карандаш",
      "append-outer-icon": "mdi-pencil-outline",
      "return-object": ""
    },
    on: {
      "click:append-outer": _vm.changeShowIdentityCardDocTypeName,
      "input": _vm.setIdentityCard
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Тип документа")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.identityCard.identityCardDocType,
      callback: function callback($$v) {
        _vm.$set(_vm.identityCard, "identityCardDocType", $$v);
      },
      expression: "identityCard.identityCardDocType"
    }
  }), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showIdentityCardDocTypeName,
      expression: "showIdentityCardDocTypeName"
    }],
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": "",
      "append-outer-icon": "mdi-pencil-outline"
    },
    on: {
      "click:append-outer": _vm.changeShowIdentityCardDocTypeName,
      "input": _vm.setIdentityCard
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Тип документа")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.identityCard.identityCardDocTypeName,
      callback: function callback($$v) {
        _vm.$set(_vm.identityCard, "identityCardDocTypeName", $$v);
      },
      expression: "identityCard.identityCardDocTypeName"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setIdentityCard
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Серия")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.identityCard.series,
      callback: function callback($$v) {
        _vm.$set(_vm.identityCard, "series", $$v);
      },
      expression: "identityCard.series"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setIdentityCard
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Номер")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.identityCard.number,
      callback: function callback($$v) {
        _vm.$set(_vm.identityCard, "number", $$v);
      },
      expression: "identityCard.number"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('DatePicker', {
    attrs: {
      "label": "Дата выдачи",
      "required": "",
      "prop-date": _vm.identityCard.issueDate
    },
    on: {
      "set-date": _vm.setIssueDate
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setIdentityCard
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Кем выдан")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.identityCard.issueBy,
      callback: function callback($$v) {
        _vm.$set(_vm.identityCard, "issueBy", $$v);
      },
      expression: "identityCard.issueBy"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('FileInput', {
    attrs: {
      "title": "Файл документа удостоверяющего личность",
      "ref-id": (_vm$identityCard = _vm.identityCard) === null || _vm$identityCard === void 0 ? void 0 : _vm$identityCard.id,
      "ref-class-name": "IdentityCard"
    },
    on: {
      "set-files": _vm.setFiles
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }